"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * Helper methods to make sure we are getting the proper values
 * for our video times
 *
 * @module VideoTimeHelpers
 */

/**
 * Get the start time of the passed playable
 *
 * @param {Playable} playable object
 * @return {number} start time
 */
function getStartTime(playable) {
  return playable && playable.startTime || 0;
}

/**
 * Get the end time of the passed playable
 *
 * @param {Playable} playable object
 * @param {number} duration from the raw player
 * @return {number} end time
 */
function getEndTime(playable, rawPlayerDuration) {
  return playable && playable.endTime || rawPlayerDuration;
}

/**
 * Calulates the duration of the passed playable
 *
 * @param {Playable} playable object
 * @param {number} duration from the raw player
 * @return {number} calculated duration
 */
function getDuration(playable, rawPlayerDuration) {
  var startTime = getStartTime(playable);
  var endTime = getEndTime(playable, rawPlayerDuration);
  return endTime - startTime;
}

/**
 * Gets the current time of the passed playable
 *
 * @param {Playable} playable object
 * @param {number} current time from the raw player
 * @return {number} current time with offset
 */
function getCurrentTime(playable, currentTime) {
  return currentTime - getStartTime(playable);
}
var _default = exports["default"] = {
  getCurrentTime: getCurrentTime,
  getDuration: getDuration,
  getEndTime: getEndTime,
  getStartTime: getStartTime
};